import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Nav';
import './blog.css';
import { posts } from './posts';

function BlogPage() {
  return (
    <div className="blog-page">
      <Navbar />
      <main className="blog-wrapper">
        <header className="blog__header">
          <p className="blog__label">Blog</p>
          <h1 className="blog__title">The Deep Cuts™️</h1>
          <p className="blog__subtitle">Click a title to read the full post. More posts coming soon.</p>
        </header>

        <div className="blog__list">
          {posts.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="blog__item">
              <div className="blog__item-text">
                <h3>{post.title}</h3>
                <p className="blog__date">{post.date}</p>
                <p className="blog__summary">{post.summary}</p>
              </div>
              <span className="blog__arrow">→</span>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}

export default BlogPage;
